import React from "react";
import Modal from 'react-bootstrap/Modal';
import { IoClose } from "react-icons/io5";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { setsnplmodal } from "../../redux/formslice"
import { NavLink } from "react-router-dom";
const Snplmodal = ({ productcost }) => {
    const dispatch = useDispatch()
    const snplmodal = useSelector((state) => state.formslice.snplmodal)
       const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    const close = () => {
        dispatch(setsnplmodal(false))
    }
    return (
        <div>
            <Modal
                show={snplmodal}
                centered
            >
                <div className="snplmodal">


                    <div className='modalclose d-flex paymentoptionsnpl  pe-2 pt-2 '>
                        <div className="paymentoption-title">
                            <div className="paytitle">

                                Payment options
                            </div>
                        </div>  <div><IoClose size={20} className="cursor-pointer" onClick={close} /></div>
                    </div>

                    <div className="monthlytitle">Monthly</div>

                    <div className="snpltrack">
                        <div className="subscription-card">

                            <div className="item activeback today">
                                <div className="indicator activeindicator"></div>
                                <div className="label activetitle">Today</div>
                                <div className="price activetitle">{currentcountry.currency} {productcost}</div>
                            </div>
                            <div className="item">
                                <div className="indicator"></div>
                                <div className="label">{moment().add(1, 'months').format("dddd, Do MMMM YYYY")}</div>
                                <div className="price">{currentcountry.currency} {productcost}</div>
                            </div>
                            <div className="item">
                                <div className="indicator"></div>
                                <div className="label">{moment().add(2, 'months').format("dddd, Do MMMM YYYY")}</div>
                                <div className="price">{currentcountry.currency} {productcost}</div>
                            </div>
                            <div className="item">
                                <div className="indicator"></div>
                                <div className="label">{moment().add(3, 'months').format("dddd, Do MMMM YYYY")}</div>
                                <div className="price">{currentcountry.currency} {productcost}</div>
                            </div>
                            <div className="track-line"></div> {/* The track line element */}
                            <div className="item">
                                <div className="indicator"></div>
                                <div className="label">{moment().add(4, 'months').format("dddd, Do MMMM YYYY")}</div>
                                <div className="price">{currentcountry.currency} {productcost}</div>
                            </div>

                        </div>
                        <NavLink to="/tabbyplan" className="activeformsubmitbutton textdecoration-none">Learn more</NavLink>
                        <div>

                        </div>

                    </div>
                </div>







            </Modal>
        </div>
    )
}
export default Snplmodal;